import DateFnsUtils from "@date-io/date-fns";
import {
  Card,
  Checkbox,
  DialogActions,
  FormControl,
  FormControlLabel,
  FormGroup,
  Grid,
  Typography,
} from "@material-ui/core";
import Button from "@material-ui/core/Button";
import CardContent from "@material-ui/core/CardContent";
import CircularProgress from "@material-ui/core/CircularProgress";
import Fab from "@material-ui/core/Fab";
import { withStyles } from "@material-ui/core/styles";
import Tooltip from "@material-ui/core/Tooltip";
import Add from "@material-ui/icons/Add";
import Search from "@material-ui/icons/Search";
import _, { debounce } from "lodash";
import { InlineDatePicker, MuiPickersUtilsProvider } from "material-ui-pickers";
import PropTypes from "prop-types";
import React, { Component } from "react";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { connect } from "react-redux";

import { get } from "../../api/apiCaller";
import SelectAutoComplete from "../../components/SelectAutoComplete";
import { mapActionsToProps } from "../../redux/campaigns";
import Dialog from "./../../components/Dialog";
import TableData from "./../../components/TableData";
import TableDataSelect from "./../../components/TableDataSelect";
import datetimeHelper from "./../../helper/datetime-helper";
import deduplicate from "./../../helper/deduplicate";
import { globalHistory } from "./../../history";
import { mapActionsToProps as agentConnect } from "./../../redux/agent";

const styles = (theme) => ({
  model: {
    width: "100%",
  },
  card: {
    maxWidth: "100%",
    overflow: "unset",
  },
  form: {
    width: "100%",
  },
  input: {
    width: "100%",
    marginTop: theme.spacing.unit * 3,
  },
  chip: {
    margin: theme.spacing.unit,
  },
  fab: {
    margin: theme.spacing.unit * 3,
    whiteSpace: "nowrap",
  },
  grid: {
    justifyContent: "center",
  },
});

function filterCustomers(array, search) {
  if (search) {
    return search
      ? array.filter(
          (item) =>
            item &&
            item.name &&
            item.name.toLowerCase().includes(search.toLowerCase())
        )
      : array;
  }
  return array;
}

class Campaign extends Component {
  constructor(props) {
    super(props);
    this.state = {
      name: "",
      note: "",
      length: 0,
      data: [],
      modalSend: false,
      filters: {
        order: "createdAt DESC",
        where: {
          gte: null,
          lte: null,
        },
        page: 0,
        pageSize: 20,
      },
      item: null,
      modalEdit: false,
      modalDelete: false,
      agents: [],
      startAt: new Date(),
      endAt: new Date(),
      checked: [],
      callsPerAgent: "",
      checkA: false,
      checkB: false,
      loading: false,
      error: false,
      campaignGroup: [],
      campaignService: [],
      campaignGroupId: null,
      campaignServiceId: null,
      listCampaign: [],
      selectedCampaign: "",
    };
  }
  componentDidMount() {
    this.itemInit();
    this.history = globalHistory();
  }

  static getDerivedStateFromProps(props, state) {
    if (
      JSON.parse(JSON.stringify(state.listCampaign)) !==
        JSON.parse(JSON.stringify(_.values(props.allCampaign))) &&
      !state.listCampaign
    ) {
      return {
        listCampaign: _.values(props.allCampaign),
      };
    }
    return null;
  }

  // componentDidUpdate(prevProps, prevState, snapshot) {
  //     const { campaignsGroup, campaignsService } = prevProps;
  //     const listCampaignGroupResult = typeof campaignsGroup === "object" ? Object.keys(campaignsGroup).map(key => campaignsGroup[key]) : campaignsGroup;
  //     const listCampaignServiceResult = typeof campaignsService === "object" ? Object.keys(campaignsService).map(key => campaignsService[key]) : campaignsService;
  //
  //     if (listCampaignGroupResult.length !== prevState.campaignGroup.length || listCampaignServiceResult.length !== prevState.campaignService.length) {
  //         console.log(listCampaignGroupResult, 'checkitem run did update')
  //         this.setState({
  //             campaignGroup: listCampaignGroupResult,
  //             campaignService: listCampaignServiceResult,
  //         });
  //     }
  // }

  listCollumns = [
    { id: "name", numeric: true, disablePadding: false, label: "Chiến dịch" },
    {
      id: "agents",
      numeric: true,
      disablePadding: true,
      label: "Số lượng điện thoại viên",
    },
    {
      id: "callsPerAgent",
      numeric: true,
      disablePadding: true,
      label: "Tỉ lệ phân bổ cuộc gọi cho ĐTV",
    },
    {
      id: "isRunning",
      numeric: true,
      disablePadding: true,
      label: "Tình trạng",
    },
    {
      id: "startAt",
      numeric: true,
      disablePadding: false,
      label: "Thời gian bắt đầu",
    },
    {
      id: "endAt",
      numeric: true,
      disablePadding: false,
      label: "Thời gian kết thúc",
    },
    {
      id: "actionDownloadCampaign",
      numeric: true,
      disablePadding: false,
      label: "Hành động",
    },
  ];

  itemInit() {
    const where = {};
    const and = [];
    const { filters } = this.state;
    for (const key in filters.where) {
      if (filters.where.hasOwnProperty(key)) {
        const element = filters.where[key];
        if (element) {
          switch (key) {
            case "name":
            default: {
              if (key.startsWith("from") || key.startsWith("to")) {
                if (key == "from") {
                  and.push({
                    startAt: {
                      gte: `${this.state.filters.where.from} 00:00:00`,
                    },
                  });
                  where.and = and;
                } else {
                  and.push({
                    endAt: { lte: `${this.state.filters.where.to} 23:59:59` },
                  });
                  where.and = and;
                }
              } else {
                where[key] = element;
              }
              break;
            }
          }
        }
      }
    }
    this.props.getListCampaigns(filters.order, filters.pageSize, filters.page, {
      where,
    });
    this.props.getAllCampaigns();
    this.props.getListCampaignsGroup(filters.order, 9999, null, null);
    this.props.getListCampaignsService(filters.order, 9999, null, null);

    this.props.countListCampaigns({
      where,
    });
    this.props.getListAgent(
      null,
      null,
      null,
      null,
      {
        include: [
          { relation: "group", scope: { fields: { id: true, name: true } } },
        ],
      },
      { query: "all" }
    );
  }

  openDialogCreate = () => {
    this.setState({ modalSend: !this.state.modalSend });
  };

  handleClose = () => {
    this.setState({
      modalSend: false,
      modalAction: false,
      modalDelete: false,
      error: false,
    });
  };

  openModalEdit = (item) => {
    this.setState(
      {
        modalAction: true,
        item: {
          ...item,
          startAt: datetimeHelper.toFormat(
            item.startAt,
            "YYYY-MM-DD startDayNoSec"
          ),
          endAt: datetimeHelper.toFormat(item.endAt, "YYYY-MM-DD endDayNoSec"),
        },
      },
      () => {
        this.props.getListCampaignsGroup(
          this.state.filters.order,
          9999,
          null,
          null
        );
        this.props.getListCampaignsService(
          this.state.filters.order,
          9999,
          null,
          null
        );
      }
    );
  };

  openModalDelete = (item) => {
    this.state.item = item;
    this.setState({ modalDelete: true });
  };

  handleChangePage = (e, page) => {
    const { filters } = this.state;
    this.setState({ page });
    filters.page = page * filters.pageSize;
    this.itemInit();
  };

  handleChangeRowsPerPage = (e) => {
    const { filters } = this.state;
    filters.pageSize = e.target.value;
    this.setState(
      {
        filters,
      },
      () => {
        this.itemInit();
      }
    );
  };

  handleSearch = (e) => {
    const value = e.target.value;
    const name = e.target.name;
    const { filters } = this.state;
    filters.where[name] = value;
    this.setState({
      filters,
    });
  };
  handleSubmit = (e) => {
    const { filters } = this.state;
    filters.skip = 0;
    if (this.state.selectedCampaign) {
      filters.where["id"] = this.state.selectedCampaign;
    } else {
      delete filters.where["id"];
    }
    this.setState(
      {
        disable: false,
        filters: {
          ...filters,
          page: 0,
        },
      },
      () => {
        setTimeout(() => {
          this.itemInit();
        }, 1000);
      }
    );
  };

  handleDateChangeStart = (from) => {
    const { filters } = this.state;
    filters.where.from = datetimeHelper.toFormat(from, "YYYY-MM-DD");
    this.setState({ from });
  };

  handleDateChangeEnd = (to) => {
    const { filters } = this.state;
    filters.where.to = datetimeHelper.toFormat(to, "YYYY-MM-DD");
    this.setState({ to });
  };

  handleChangeText = (name) => {
    return (e) => {
      this.setState({
        [name]: e.target.value,
      });
    };
  };

  handleChangeTextEdit = (name) => {
    return (e) => {
      this.setState({
        item: {
          ...this.state.item,
          [name]: e.target.value,
        },
      });
    };
  };

  handleCreateModel = () => {
    this.setState({ modalAction: true, item: {} });
  };

  handleAction = () => {
    const { id, listAgent } = this.state.item;
    let dataAgent = [];
    let listDataAgent = [];
    if (!id) {
      this.state.checked.map((item) => {
        dataAgent.push(item.id);
      });
      const data = deduplicate.deduplicate(dataAgent);
      const {
        name,
        note,
        callsPerAgent,
        startAt,
        endAt,
        agents,
        campaignGroupId,
        campaignServiceId,
      } = this.state;
      if (data.length) {
        return (
          this.props.addNewCampaign(
            name,
            note,
            callsPerAgent,
            startAt,
            endAt,
            data,
            campaignGroupId,
            campaignServiceId
          ),
          setTimeout(
            function () {
              this.setState({
                modalAction: false,
                error: false,
                campaignGroupId: null,
                campaignServiceId: null,
                name: "",
              });
              this.itemInit();
            }.bind(this),
            1000
          )
        );
      } else {
        this.setState({
          error: true,
          campaignGroupId: null,
          campaignServiceId: null,
          name: "",
        });
      }
    } else {
      const {
        id,
        isRunning,
        name,
        note,
        callsPerAgent,
        startAt,
        endAt,
        campaignGroupId,
        campaignServiceId,
      } = this.state.item;
      listAgent.map((i) => {
        listDataAgent.push(i.id);
      });
      const dataList = deduplicate.deduplicate(listDataAgent);
      if (dataList.length) {
        return (
          this.props.editCampaign(
            id,
            isRunning,
            name,
            note,
            callsPerAgent,
            startAt,
            endAt,
            dataList,
            campaignGroupId,
            campaignServiceId
          ),
          setTimeout(
            function () {
              this.setState({
                modalAction: false,
                error: false,
                campaignGroupId: null,
                campaignServiceId: null,
                name: "",
              });
              // this.itemInit()
            }.bind(this),
            1000
          )
        );
      } else {
        this.setState({
          error: true,
          campaignGroupId: null,
          campaignServiceId: null,
          name: "",
        });
      }
    }
  };

  handleDownload = (item) => {
    this.setState(
      {
        loading: true,
      },
      () => {
        get(
          `mini-crm/interactive-log/export-interactive-log?campaignId=${item.id}`
        )
          .then((data) => {
            window.location.href = `${process.env.REACT_APP_API_PROTOCOL}://${process.env.REACT_APP_API_HOST}/media-mgt/container/mini-crm/download/${data.data}`;
            this.setState({
              loading: false,
            });
          })
          .catch((error) => {
            this.setState({
              loading: false,
            });
          });
      }
    );
  };

  handleDelete = () => {
    this.props.deleteCampaign(this.state.item.id);
    setTimeout(
      function () {
        this.setState({ modalDelete: false });
        this.itemInit();
      }.bind(this),
      500
    );
  };

  handleDateChangeFrom = (date) => {
    this.setState({
      startAt: datetimeHelper.toFormat(date, "YYYY-MM-DD startDayNoSec"),
    });
  };

  handleDateChangeTo = (date) => {
    this.setState({
      endAt: datetimeHelper.toFormat(date, "YYYY-MM-DD endDayNoSec"),
    });
  };

  handleDateChangeFromEdit = (date) => {
    this.setState({
      item: {
        ...this.state.item,
        startAt: datetimeHelper.toFormat(date, "YYYY-MM-DD startDayNoSec"),
      },
    });
  };

  handleDateChangeToEdit = (date) => {
    this.setState({
      item: {
        ...this.state.item,
        endAt: datetimeHelper.toFormat(date, "YYYY-MM-DD endDayNoSec"),
      },
    });
  };

  handleConfig = (item) => {
    this.history.push(
      `${process.env.REACT_APP_PATH}/mini-crm/campaign-config/${item.id}`
    );
  };

  handleSelectedItem = (item) => {
    this.state.agents = item;
  };

  handleToggle = (value) => {
    const { checked } = this.state;
    const currentIndex = checked.indexOf(value);
    const newChecked = [...checked];
    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    this.setState({
      checked: newChecked,
    });
  };

  handleToggleChecked = (value) => {
    const { listAgent, checked } = this.state.item;
    const currentIndex = listAgent.indexOf(value);
    let newChecked;
    newChecked = listAgent;
    if (currentIndex === -1) {
      newChecked = listAgent.filter((i) => i.id !== value.id);
      newChecked.push(value);
    } else {
      newChecked.splice(currentIndex, 1);
    }
    this.setState({
      item: {
        ...this.state.item,
        listAgent: newChecked,
      },
    });
  };

  handlePlay = async (item) => {
    const { id, isRunning, name, note, callsPerAgent, startAt, endAt, agents } =
      item;
    this.props.editCampaign(
      id,
      true,
      name,
      note,
      callsPerAgent,
      startAt,
      endAt,
      agents
    );
    setTimeout(
      function () {
        this.itemInit();
      }.bind(this),
      500
    );
  };

  handlePause = async (item) => {
    const { id, isRunning, name, note, callsPerAgent, startAt, endAt, agents } =
      item;
    this.props.editCampaign(
      id,
      false,
      name,
      note,
      callsPerAgent,
      startAt,
      endAt,
      agents
    );
    setTimeout(
      function () {
        this.itemInit();
      }.bind(this),
      500
    );
  };

  handleCheckStage = (name) => {
    return (e) => {
      this.setState({
        callsPerAgent: e.target.value,
        checkA: !this.state.checkA,
        checkB: !this.state.checkB,
      });
    };
  };

  handleCheckStageEdit = (name) => {
    return (e) => {
      this.setState({
        item: {
          ...this.state.item,
          callsPerAgent: e.target.value,
        },
        checkA: !this.state.checkA,
        checkB: !this.state.checkB,
      });
    };
  };

  handleToggleAll = (event) => {
    const { listAgents } = this.props;
    const listAgentResult =
      typeof listAgents === "object"
        ? Object.keys(listAgents).map((key) => listAgents[key])
        : listAgents;
    if (event.target.checked) {
      this.setState({
        checked: listAgentResult.map((n) => n),
        item: {
          ...this.state.item,
          listAgent: listAgentResult.map((n) => n),
        },
      });
      return;
    }
    this.setState({
      checked: [],
      item: {
        ...this.state.item,
        listAgent: [],
      },
    });
  };

  handleSearchCampaign = (text, type) => {
    const { campaignsGroup, campaignsService } = this.props;
    const listCampaignGroupResult =
      typeof campaignsGroup === "object"
        ? Object.keys(campaignsGroup).map((key) => campaignsGroup[key])
        : campaignsGroup;
    const listCampaignServiceResult =
      typeof campaignsService === "object"
        ? Object.keys(campaignsService).map((key) => campaignsService[key])
        : campaignsService;
    if (type === "group") {
      this.setState({
        campaignGroup: filterCustomers(listCampaignGroupResult, text),
      });
    }

    if (type === "service") {
      this.setState({
        campaignService: filterCustomers(listCampaignServiceResult, text),
      });
    }
  };

  filterCustomers = (array, search) => {
    if (search) {
      return search
        ? array.filter(
            (item) =>
              item &&
              item.name &&
              item.name.toLowerCase().includes(search.toLowerCase())
          )
        : array;
    }
    return array;
  };

  handleSearchUser = (text) => {
    const { allCampaign } = this.props;
    this.setState({
      listCampaign: this.filterCustomers(_.values(allCampaign), text),
    });
  };

  render() {
    const {
      classes,
      listCampaign,
      listAgents,
      count,
      campaignsGroup,
      campaignsService,
    } = this.props;
    const {
      id,
      name,
      note,
      providerId,
      filters,
      item,
      modalDelete,
      modalAction,
      startAt,
      endAt,
      agents,
      callsPerAgent,
    } = this.state;
    const listCampaignResult =
      typeof listCampaign === "object"
        ? Object.keys(listCampaign).map((key) => listCampaign[key])
        : listCampaign;
    const listAgentResult =
      typeof listAgents === "object"
        ? Object.keys(listAgents).map((key) => listAgents[key])
        : listAgents;

    const listCampaignGroupResult =
      typeof campaignsGroup === "object"
        ? Object.keys(campaignsGroup).map((key) => campaignsGroup[key])
        : campaignsGroup;
    const listCampaignServiceResult =
      typeof campaignsService === "object"
        ? Object.keys(campaignsService).map((key) => campaignsService[key])
        : campaignsService;

    return (
      <React.Fragment>
        <ValidatorForm
          ref="form"
          onSubmit={this.handleSubmit}
          onError={(errors) => console.log(errors)}
          className={classes.form}>
          <Card className={classes.card}>
            <CardContent>
              <FormControl className={classes.form}>
                <FormGroup className={classes.form}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <Grid container spacing={24}>
                      <Grid item md={3}>
                        <SelectAutoComplete
                          label={"Tên chiến dịch"}
                          data={
                            this.state.listCampaign &&
                            this.state.listCampaign.length > 0
                              ? this.state.listCampaign.map((val) => {
                                  return {
                                    id: val.id,
                                    label: val.name ? `${val.name}` : "",
                                  };
                                })
                              : []
                          }
                          onSearch={debounce(
                            (text) => this.handleSearchUser(text),
                            300
                          )}
                          onChange={(item) => {
                            this.setState(
                              {
                                selectedCampaign: item ? item.id : "",
                              },
                              () => {
                                this.handleSubmit();
                              }
                            );
                          }}
                          className={classes.input}
                          onClear={true}
                          name="agentId"
                        />
                      </Grid>
                      <Grid item md={3}>
                        <InlineDatePicker
                          margin="normal"
                          label="Thời gian bắt đầu"
                          variant="outlined"
                          className={classes.input}
                          value={filters.where.from ? filters.where.from : null}
                          maxDate={new Date()}
                          format="dd-MM-yyyy"
                          onChange={this.handleDateChangeStart}
                          name="from"
                        />
                      </Grid>
                      <Grid item md={3}>
                        <InlineDatePicker
                          margin="normal"
                          label="Thời gian kết thúc"
                          variant="outlined"
                          className={classes.input}
                          value={filters.where.to ? filters.where.to : null}
                          maxDate={new Date()}
                          minDate={filters.where.from}
                          format="dd-MM-yyyy"
                          onChange={this.handleDateChangeEnd}
                          name="to"
                        />
                      </Grid>

                      <Grid item md={3}>
                        <Tooltip title="Tìm kiếm" disableFocusListener>
                          <Fab
                            color="primary"
                            aria-label="Search"
                            className={classes.fab}
                            onClick={this.handleSubmit}>
                            <Search />
                          </Fab>
                        </Tooltip>
                      </Grid>
                    </Grid>
                  </MuiPickersUtilsProvider>
                </FormGroup>
              </FormControl>
            </CardContent>
          </Card>
        </ValidatorForm>
        {}
        <TableData
          {...this.props}
          nameTable="Danh sách chiến dịch"
          items={listCampaignResult}
          rowsPerPage={filters.pageSize}
          count={count}
          page={
            filters.pageSize === 20
              ? filters.page / 20
              : filters.pageSize === 40
              ? filters.page / 40
              : filters.pageSize === 60
              ? filters.page / 60
              : filters.pageSize === 80
              ? filters.page / 80
              : filters.page / 100
          }
          rowItems={this.listCollumns}
          allowCreate={true}
          handleEdit={this.openModalEdit}
          handleDelete={this.openModalDelete}
          handleChangePage={this.handleChangePage}
          handleChangeRowsPerPage={this.handleChangeRowsPerPage}
          handleConfig={this.handleConfig}
          handlePlay={this.handlePlay}
          handlePause={this.handlePause}
          handleDownload={this.handleDownload}
          createAction={
            <Tooltip title="Thêm mới" disableFocusListener>
              <Fab
                color="primary"
                aria-label="add"
                className={classes.fab}
                size="small"
                onClick={this.handleCreateModel}>
                <Add className={classes.add} />
              </Fab>
            </Tooltip>
          }
        />
        <Dialog
          open={this.state.modalAction}
          fullScreen={false}
          title={
            item
              ? item.id
                ? "Chỉnh sửa thông tin chiến dịch"
                : "Thêm chiến dịch"
              : null
          }
          onClose={() => this.setState({ modalAction: false })}
          input={
            <ValidatorForm
              ref="form"
              onSubmit={this.handleAction}
              onError={(errors) => console.log(errors)}
              className={classes.form}>
              <FormControl className={classes.form}>
                <Grid container className={classes.grid}>
                  <MuiPickersUtilsProvider utils={DateFnsUtils}>
                    <TextValidator
                      id="outlined-full-width"
                      margin="normal"
                      label="Tên chiến dịch"
                      variant="outlined"
                      className={classes.input}
                      autoFocus={true}
                      onChange={
                        item
                          ? item.id
                            ? this.handleChangeTextEdit("name")
                            : this.handleChangeText("name")
                          : null
                      }
                      value={item ? (item.id ? item.name : name) : null}
                      name="name"
                      validators={["required"]}
                      errorMessages="Không được để trống"
                    />
                    <SelectAutoComplete
                      id="group"
                      label={"Nhóm chiến dịch"}
                      data={
                        this.state.campaignGroup &&
                        this.state.campaignGroup.length > 0
                          ? this.state.campaignGroup.map((val) => {
                              return {
                                id: val.id,
                                label: val.name,
                              };
                            })
                          : listCampaignGroupResult.map((val) => {
                              return {
                                id: val.id,
                                label: val.name,
                              };
                            })
                      }
                      onSearch={debounce(
                        (text) => this.handleSearchCampaign(text, "group"),
                        300
                      )}
                      className={classes.input}
                      value={
                        this.props.loadingGroup === false &&
                        item &&
                        item.campaignGroupId
                          ? item.campaignGroupId
                          : ""
                      }
                      required={true}
                      onChange={(val) => {
                        if (item && item.id) {
                          this.setState({
                            item: {
                              ...item,
                              campaignGroupId: val && val.id ? val.id : "",
                            },
                          });
                        } else {
                          this.setState({
                            campaignGroupId: val && val.id ? val.id : "",
                          });
                        }
                      }}
                      onClear={true}
                    />
                    <SelectAutoComplete
                      id="service"
                      label={"Dịch vụ chiến dịch"}
                      data={
                        this.state.campaignService &&
                        this.state.campaignService.length > 0
                          ? this.state.campaignService.map((val) => {
                              return {
                                id: val.id,
                                label: val.name,
                              };
                            })
                          : listCampaignServiceResult.map((val) => {
                              return {
                                id: val.id,
                                label: val.name,
                              };
                            })
                      }
                      onSearch={debounce(
                        (text) => this.handleSearchCampaign(text, "service"),
                        300
                      )}
                      required={true}
                      value={
                        this.props.loadingService === false &&
                        item &&
                        item.campaignServiceId
                          ? item.campaignServiceId
                          : ""
                      }
                      className={classes.input}
                      onChange={(val) => {
                        if (item && item.id) {
                          this.setState({
                            item: {
                              ...item,
                              campaignServiceId: val && val.id ? val.id : "",
                            },
                          });
                        } else {
                          this.setState({
                            campaignServiceId: val && val.id ? val.id : "",
                          });
                        }
                      }}
                      onClear={true}
                    />
                    <InlineDatePicker
                      margin="normal"
                      label="Thời gian bắt đầu"
                      variant="outlined"
                      className={classes.input}
                      value={item ? (item.id ? item.startAt : startAt) : null}
                      maxDate={new Date()}
                      format="yyyy-MM-dd"
                      onChange={
                        item
                          ? item.id
                            ? this.handleDateChangeFromEdit
                            : this.handleDateChangeFrom
                          : null
                      }
                      name="startAt"
                      validators={["required"]}
                      errorMessages="Không được để trống"
                    />
                    <InlineDatePicker
                      margin="normal"
                      label="Thời gian kết thúc"
                      variant="outlined"
                      className={classes.input}
                      value={item ? (item.id ? item.endAt : endAt) : null}
                      minDate={item ? (item.id ? item.startAt : startAt) : null}
                      format="yyyy-MM-dd"
                      onChange={
                        item
                          ? item.id
                            ? this.handleDateChangeToEdit
                            : this.handleDateChangeTo
                          : null
                      }
                      name="endAt"
                      validators={["required"]}
                      errorMessages="Không được để trống"
                    />
                    <Typography>
                      ** Tỉ lệ phân bổ cuộc gọi cho điện thoại viên
                    </Typography>
                    <FormControlLabel
                      style={{ marginRight: "300px", marginTop: "10px" }}
                      control={
                        <Checkbox
                          onChange={
                            item
                              ? item.id
                                ? this.handleCheckStageEdit("callsPerAgent")
                                : this.handleCheckStage("callsPerAgent")
                              : null
                          }
                          value="0"
                          color="primary"
                          name="Tự động"
                          checked={this.state.disabled}
                        />
                      }
                      label="Tự động"
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          onChange={
                            item
                              ? item.id
                                ? this.handleCheckStageEdit("callsPerAgent")
                                : this.handleCheckStage("callsPerAgent")
                              : null
                          }
                          value="1"
                          color="primary"
                          name="1:1"
                          checked={this.state.disabled}
                        />
                      }
                      label="1:1"
                    />
                    {this.state.checkA === false &&
                    this.state.checkB === false ? (
                      <TextValidator
                        variant="outlined"
                        label="Tùy chỉnh tỉ lệ"
                        className={classes.input}
                        onChange={
                          item
                            ? item.id
                              ? this.handleChangeTextEdit("callsPerAgent")
                              : this.handleChangeText("callsPerAgent")
                            : null
                        }
                        value={
                          item
                            ? item.id
                              ? item.callsPerAgent
                              : callsPerAgent
                            : null
                        }
                        name="callsPerAgent"
                        validators={[
                          "minNumber:2",
                          "required",
                          "matchRegexp:^[0-9]+$",
                        ]}
                        errorMessages={[
                          "Số lớn hơn 1",
                          "Không được để trống",
                          "Chỉ được nhập số",
                        ]}
                      />
                    ) : null}
                    <TextValidator
                      id="outlined-full-width"
                      margin="normal"
                      label="Ghi chú"
                      variant="outlined"
                      multiline
                      rows={5}
                      className={classes.input}
                      onChange={
                        item
                          ? item.id
                            ? this.handleChangeTextEdit("note")
                            : this.handleChangeText("note")
                          : null
                      }
                      value={item ? (item.id ? item.note : note) : null}
                      name="note"
                    />
                  </MuiPickersUtilsProvider>
                </Grid>
                <TableDataSelect
                  style={{ border: "1px solid red !important" }}
                  items={listAgentResult}
                  handleSelect={this.handleSelectedItem}
                  title="Lựa chọn điện thoại viên tham gia chiến dịch"
                  checked={
                    item
                      ? item.id
                        ? item.listAgent
                        : this.state.checked
                      : this.state.checked
                  }
                  handleToggle={
                    item
                      ? item.id
                        ? this.handleToggleChecked
                        : this.handleToggle
                      : this.handleToggle
                  }
                  handleToggleAll={this.handleToggleAll}
                />
                {this.state.error && (
                  <p className="error-messages">
                    Vui lòng chọn điện thoại viên
                  </p>
                )}
              </FormControl>
              <DialogActions>
                <Button
                  onClick={this.handleClose}
                  color="secondary"
                  className={classes.button}>
                  Hủy
                </Button>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  className={classes.button}>
                  Lưu
                </Button>
              </DialogActions>
            </ValidatorForm>
          }
        />
        <Dialog
          open={modalDelete}
          title={`Bạn có muốn xóa chiến dịch?`}
          button={true}
          onSubmit={this.handleDelete}
          onClose={this.handleClose}
        />
        <Dialog open={this.props.loading} title={<CircularProgress />} />
        <Dialog open={this.state.loading} title={<CircularProgress />} />
      </React.Fragment>
    );
  }
}

Campaign.propTypes = {
  classes: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  listCampaign: state.campaign.campaigns,
  listAgents: state.agent.agents,
  dataCampaignEdit: state.campaign.dataCampaignEdit,
  loading: state.campaign.loading,
  count: state.campaign.count,
  campaignsGroup: state.campaign.campaignsGroup,
  campaignsService: state.campaign.campaignsService,
  allCampaign: state.campaign.allCampaign,
  loadingGroup: state.campaign.loadingGroup,
  loadingService: state.campaign.loadingService,
});
const Agent = connect(mapStateToProps, agentConnect)(Campaign);
Campaign = connect(null, mapActionsToProps)(Agent);

export default withStyles(styles)(Campaign);
